// api/accountWatermarks.ts
/**
 * API client for the account watermarks probe.
 *
 * Poll `getAccountWatermarks()` and refetch a list when its watermark
 * differs from the value you had — see the backend route docstring
 * (`apps/backend/api/routes/account_watermarks_routes.py`) for the full
 * rationale and the "compare for inequality, not for being newer" rule.
 */

import { apiJson } from "./client";

// ============================================================================
// Types
// ============================================================================

export type ResourceWatermark = {
  count: number;
  max_updated_at: string | null;
};

export type AccountWatermarks = {
  dashboards: ResourceWatermark;
  data_sources: ResourceWatermark;
  last_mcp_write_at: string | null;
};

// ============================================================================
// Endpoint
// ============================================================================

export async function getAccountWatermarks(): Promise<AccountWatermarks> {
  return apiJson<AccountWatermarks>("/accounts/watermarks");
}
